export default {"src":"/_next/static/media/unsecured-bussiness-loan.8f1656a5.svg","height":57,"width":57,"blurWidth":0,"blurHeight":0};